import React, { useState, useEffect } from 'react';
import { ButtonMenuContainer, ButtonMenuTrigger, ButtonMenuMenu, ButtonMenuItem, Button, IconArrowDown } from '@seismic/mantle';
import { KeyBoardAction } from './util';

const MorePrivacyLinks = (props) => {
    const { privacyLinkUrls, hilightColor, clickHandler, updateSelectLink } = props;
    const defaultPrivacyLink = privacyLinkUrls.find(l => l.isDefault);
    const [selectUrl, setSelectUrl] = useState(defaultPrivacyLink);
    const isShowDropDown = privacyLinkUrls.length > 1;
    const { name, url } = selectUrl;

    const onSelectUrl = (e, item) => {
        // Main button pressed, usually the left button or the un-initialized state
        if (e && (e.button === 0 || e.keyCode === KeyBoardAction.enter)) {
            setSelectUrl(item);
            if (item.url) {
                window.open(item.url);
            }

            if (updateSelectLink) {
                const newPrivacyLinks = privacyLinkUrls.map((link) => {
                    if (link.id === item.id) {
                        return { ...item, isDefault: true };
                    }

                    return { ...link, isDefault: false };
                });
                updateSelectLink(newPrivacyLinks);
            }
        }
    };

    useEffect(() => {
        setSelectUrl(defaultPrivacyLink);
    }, [defaultPrivacyLink]);

    return (
        <span className="engagement-viewer-privacy-policy-links" >
            <a className="privacy-policy-links"
                rel="noopener noreferrer"
                target="_blank"
                title={name}
                href={url}
                onClick={clickHandler}
                style={{ color: hilightColor }}>
                {name}
            </a>
            {isShowDropDown && (
                <ButtonMenuContainer>
                    <ButtonMenuTrigger>
                        <Button label="open privacy link" style={{ color: hilightColor }} className="privacy-policy-links-trigger" startAdornment={IconArrowDown} iconSize={16} hideLabel variant="ghost" />
                    </ButtonMenuTrigger>
                    <ButtonMenuMenu>
                        {privacyLinkUrls.map(l => (
                            <ButtonMenuItem
                                className="privacy-url-list-item"
                                key={l.name}
                                onMouseDown={e => onSelectUrl(e, l)}
                                onKeyDown={e => onSelectUrl(e, l)}
                            >
                                {l.name}
                            </ButtonMenuItem>
                        ))}
                    </ButtonMenuMenu>
                </ButtonMenuContainer>
            )}
        </span>
    );
};

const DumpPrivacyLink = (props) => {
    const { privacyLinkUrl, privacyPolicyText, hilightColor, clickHandler, updateSelectLink } = props;

    if (!privacyLinkUrl || (Array.isArray(privacyLinkUrl) && privacyLinkUrl.length === 0)) return null;

    if (typeof privacyLinkUrl === 'string') {
        return (<a className="privacy-policy-link"
            rel="noopener noreferrer"
            href={privacyLinkUrl}
            target="_blank"
            onClick={clickHandler}
            style={{ color: hilightColor }}>
            {privacyPolicyText}
        </a>);
    }

    return (<MorePrivacyLinks
        clickHandler={clickHandler}
        privacyLinkUrls={privacyLinkUrl}
        hilightColor={hilightColor}
        updateSelectLink={updateSelectLink} />);
};

export default DumpPrivacyLink;
